import request from './request';
import type {UserInfoResponse, LogoutResponse} from '@/types/auth';

/** 获取当前登录用户信息 */
export const fetchUserInfo = (params?: {redir?: string}) =>
    request.get<UserInfoResponse>('/proxy-aicomic/user/info', {
        params: {redir: params?.redir ?? window.location.href},
    });

/** 退出登录 */
export const fetchLogout = () => request.get<LogoutResponse>('/proxy-aicomic/user/logout');
